import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { ClassificationListSortField, SortingOrder } from "@/graphql/codegen/graphql"
import ProductClassContainer from "@/screens/ManageProducts/components/ProductClasses/containers/ProductClassContainer"

const SearchParamsValidator = z.object({
  query: z.string().optional(),
  field: fallback(z.nativeEnum(ClassificationListSortField), ClassificationListSortField.Category),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
  productManagerIds: z.array(z.string()).optional(),
  categoryIds: z.array(z.string()).optional(),
  classIds: z.array(z.string()).optional(),
  isNotAssociated: z.boolean().nullish(),
})

// Get keys as a Zod schema
const keysSchema = SearchParamsValidator.keyof()

export const Route = createFileRoute("/app/admin/manage-products/_layout/classes")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(keysSchema.options)],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.PRODUCT_MAINTENANCE]}>
      <ProductClassContainer />
    </PermissionContentWrapper>
  ),
})
